<template>
    <label class="ds-ex-field ds-ex-search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
        <input v-model="text" type="text" :placeholder="placeholder" :aria-label="placeholder" maxlength="100" @input="emitLater">
        <button v-if="text" type="button" class="ds-ex-search-clear" aria-label="Очистить поиск" @click="clear">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
        </button>
    </label>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import debounce from 'lodash.debounce'

withDefaults(defineProps<{ placeholder?: string }>(), { placeholder: 'Поиск по сотруднику' })

// Серверный поиск: значение уходит наружу после паузы ввода.
const model = defineModel<string>({ required: true })
const text = ref(model.value)

watch(model, value => { if (value !== text.value.trim()) text.value = value })

const emitLater = debounce(() => { model.value = text.value.trim() }, 500)

function clear() {
    emitLater.cancel()
    text.value = ''
    model.value = ''
}

onBeforeUnmount(() => emitLater.flush())
</script>
